import ExchangeModal from '@moncler/components/bag/ExchangeModal';
import { MinicartActionTypes } from '@state/features/common.types';
import { minicartQuantitySelector } from '@state/features/minicart.selectors';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { menu } from '@utils/constants';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MiniBagModal from './MiniBagModal';
const LoginModal = React.lazy(() => import('@components/login/LoginModal'));
const MiniBagWrapper = (props) => {
    var _a;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { justAdded, hovering, lastAdded, minicart } = useSelector((state) => state.minicart);
    const numItems = useSelector(minicartQuantitySelector);
    const [isDesktop, setIsDesktop] = useState(false);
    const mouseIn = useRef();
    const mouseOut = useRef();
    const [loginOpen, setLoginOpen] = useState(false);
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const [bag, setBag] = useState(); // only used for exchange alert, normally not loaded
    const wrapper = useRef(null);
    const lastAddedRef = useRef();
    lastAddedRef.current = lastAdded;
    const currentBreakpoint = useBreakpoint();
    // Total products in cart - initiallly use the prop while redux state loads
    const definitiveTotal = useMemo(() => {
        return numItems !== null && numItems !== void 0 ? numItems : props.totalItems;
    }, [numItems]);
    const prevStatus = useRef(justAdded || hovering);
    const overlayVisible = useMemo(() => justAdded || hovering, [justAdded, hovering]);
    useEffect(() => {
        setIsDesktop(currentBreakpoint >= window.mqObj.md);
    }, [currentBreakpoint]);
    useEffect(() => {
        if (window.location.search.includes('isExchange=true')) {
            api.getFullCart().then((data) => setBag(data));
        }
        if (window.location.search.includes('openMiniCart')) {
            dispatch({ type: MinicartActionTypes.FETCH_MINICART_AND_OPEN });
        }
    }, []);
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    const onOpenMinibag = () => {
        var _a;
        document.body.classList.add('overlay');
        document.body.classList.add('overlay-open');
        document.body.classList.add('no-overflow');
        document.body.style.setProperty('--scrollbar-width', scrollBarWidth + 'px');
        (_a = document.querySelector('#infinite-scroll-wrapper')) === null || _a === void 0 ? void 0 : _a.classList.add('minicart-overlay');
        // document.querySelector('.navigation').classList.add('navigation-white');
    };
    const onCloseMinibag = () => {
        var _a;
        document.body.classList.remove('overlay');
        document.body.classList.remove('overlay-open');
        document.body.classList.remove('no-overflow');
        document.body.style.removeProperty('--scrollbar-width');
        (_a = document.querySelector('#infinite-scroll-wrapper')) === null || _a === void 0 ? void 0 : _a.classList.remove('minicart-overlay');
        // document.querySelector('.navigation').classList.remove('navigation-white');
    };
    useEffect(() => {
        // console.info('overlay visible: ', overlayVisible);
        if (overlayVisible && !prevStatus.current) {
            prevStatus.current = true;
            onOpenMinibag();
        }
        else if (prevStatus.current) {
            prevStatus.current = false;
            onCloseMinibag();
        }
    }, [overlayVisible]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "minibag-wrapper", onMouseEnter: () => {
                clearTimeout(mouseIn.current);
                clearTimeout(mouseOut.current);
                mouseIn.current = setTimeout(() => {
                    if (isDesktop && !overlayVisible) {
                        dispatch({ type: MinicartActionTypes.FETCH_MINICART_AND_OPEN });
                    }
                }, menu.overlay.timeout);
            }, onMouseLeave: () => {
                var _a;
                clearTimeout(mouseIn.current);
                clearTimeout(mouseOut.current);
                // for new Chrome version, when the focus is on the input and appear the chrome autosuggestion modal, the mouseleave event is triggered
                // this is a workaround to avoid the minibag to close in this case
                let focusedInput = (_a = wrapper.current) === null || _a === void 0 ? void 0 : _a.querySelector('input:focus');
                mouseOut.current = setTimeout(() => {
                    if (isDesktop && overlayVisible && !justAdded && !focusedInput)
                        dispatch({ type: MinicartActionTypes.CLOSE_MINICART });
                }, menu.overlay.timeout);
            } },
            React.createElement("button", { className: "icon--bag", type: "button", "aria-label": definitiveTotal > 0 ? t('bag.icon.notempty.arialabel', { 0: definitiveTotal }) : t('bag.icon.empty.arialabel'), "aria-haspopup": 'dialog', onClick: (e) => {
                    if (isDesktop && (document.body.classList.contains('keyboard-mode') || document.documentElement.getAttribute('data-whatintent') == 'touch')) {
                        dispatch({ type: MinicartActionTypes.FETCH_MINICART_AND_OPEN });
                    }
                    else {
                        window.location.href = props.carturl;
                        analytics.header('shopping bag', true);
                    }
                } }, definitiveTotal > 0 && React.createElement("span", { "aria-hidden": "true" }, definitiveTotal)),
            React.createElement(FocusTrap, { focusTrapOptions: {
                    onDeactivate: () => {
                        // console.info('on deactivate minibag focus trap');
                        // if (whatInput.ask() == 'keyboard') {
                        dispatch({ type: MinicartActionTypes.CLOSE_MINICART });
                        // }
                        analytics.miniBagClose();
                        // if (lastAdded) {
                        //   const tile = document.querySelector(`[data-id="${lastAdded}"]`) as HTMLElement;
                        //   setTimeout(() => {
                        //     tile?.focus();
                        //   }, 550);
                        // }
                    },
                    initialFocus: () => wrapper.current,
                    fallbackFocus: () => wrapper.current,
                    setReturnFocus: (el) => {
                        // console.info(el);
                        /*    if (lastAddedRef.current) {
                          let lastEl = document.querySelector(`[data-id="${lastAddedRef.current}"] .product-tile__link`) as HTMLElement;
                          return lastEl ?? el;
                        } */
                        return document.body;
                    },
                    clickOutsideDeactivates: true,
                }, active: overlayVisible },
                React.createElement("div", { ref: wrapper, className: classNames('minibag', { 'has-items': definitiveTotal != 0 }, { visible: overlayVisible }), "aria-modal": "true", role: "dialog", tabIndex: -1, "aria-label": justAdded ? t('bag.aria.justadded') : t('bag.summary') },
                    React.createElement("div", { className: "a11y-action-bar" },
                        React.createElement("a", { href: props.carturl },
                            React.createElement("span", null, t('navigation.aria.navigatetobag'))),
                        definitiveTotal == 0 && (React.createElement("button", { onClick: () => {
                                dispatch({ type: MinicartActionTypes.CLOSE_MINICART });
                            }, type: "button", "aria-label": t('button.close'), className: "button-close" }))),
                    React.createElement(MiniBagModal, Object.assign({ logged: loggedIn, faqurl: props.faqurl, onLoginClick: () => setLoginOpen(true), onClose: () => dispatch({ type: MinicartActionTypes.CLOSE_MINICART }), updateLoggeedStatus: () => setLoggedIn(true), showLoginBox: currentBreakpoint >= window.mqObj.sm, isDesktop: isDesktop }, props)),
                    React.createElement(LoginModal, Object.assign({}, props, { privacypolicy: props.privacypolicy, inCart: true, reloadPage: true, fromMbm: minicart === null || minicart === void 0 ? void 0 : minicart.containsMbm, modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status), updateLoggeedStatus: () => setLoggedIn(true), socialLoginTarget: "checkout" }))))),
        ((_a = bag === null || bag === void 0 ? void 0 : bag.exchangeModel) === null || _a === void 0 ? void 0 : _a.alert) && React.createElement(ExchangeModal, { bag: bag })));
};
export default MiniBagWrapper;
